module.exports = __webpack_public_path__ + "img/sj.ea43d058.svg";